module.exports = __webpack_public_path__ + "img/yinlian.66e71ad3.svg";